export const industriesData = [
  {
    title: "Information Technology & Digital Services",
    challenge: "The IT industry is fast-paced, with continuous demand for niche skills, scalable products, and innovation.",
    solution: [
      "Talent acquisition for full-stack developers, cloud engineers, QA automation specialists, and niche tech roles.",
      "Development of enterprise-grade software using modern stacks like Java, .NET, Python, Node.js, React, Angular, Flutter.",
      "DevOps and cloud solutions on AWS, Azure, and GCP.",
      "Cybersecurity and data-driven analytics for future-ready businesses."
    ],
    impact: "We help IT companies scale faster, reduce project delivery timelines, and build secure, high-performing platforms."
  },
  {
    title: "Healthcare & Life Sciences",
    challenge: "The healthcare sector faces challenges of patient management, skilled workforce availability, and adoption of AI-driven diagnostics.",
    solution: [
      "AestheTech – AI-powered clinic management system with imaging support and AI-assist for junior doctors.",
      "Quantum Quest (SureCare) – On-demand staffing platform for nurses and healthcare professionals.",
      "Recruitment of specialized talent in healthcare IT, hospital management, and medical R&D."
    ],
    impact: "Our solutions improve patient outcomes, reduce operational bottlenecks, and ensure availability of skilled professionals."
  },
  {
    title: "Education & Training",
    challenge: "Traditional education methods often struggle with digital transformation and personalized learning.",
    solution: [
      "NITO (Electus) – Mock test platform for IIT/JEE, GATE, TTC, and other competitive exams.",
      "Staffing solutions for EdTech firms, hiring developers, content specialists, and education consultants.",
      "AI-driven platforms for digital learning and performance analytics."
    ],
    impact: "Institutions and students gain from smarter, scalable, and tech-driven learning experiences."
  },
  {
    title: "Finance & Consulting",
    challenge: "The financial sector requires precision, compliance, and secure IT solutions, while consulting firms need niche talent quickly.",
    solution: [
      "RPO services for BFSI and consulting firms to close niche roles faster.",
      "Development of secure, compliant digital platforms with AI/ML-driven analytics.",
      "Workforce management through HRMS with integrated payroll and compliance."
    ],
    impact: "Improved compliance, reduced costs, faster hiring, and secure technology systems."
  },
  {
    title: "Retail & E-commerce",
    challenge: "The retail industry demands seamless omnichannel experiences, real-time inventory, and customer personalization.",
    solution: [
      "AI-powered recommendation engines for personalized shopping.",
      "E-commerce app & website development with scalable payment solutions.",
      "Supply chain automation and inventory management platforms.",
      "Talent acquisition for digital marketers, UI/UX designers, and retail tech experts."
    ],
    impact: "We enable retailers to increase sales, improve customer engagement, and optimize supply chain efficiency."
  },
  {
    title: "Manufacturing & Supply Chain",
    challenge: "Manufacturers face challenges with Industry 4.0 adoption, workforce upskilling, and operational efficiency.",
    solution: [
      "IoT-driven predictive maintenance and smart factory solutions.",
      "ERP implementation for supply chain and production planning.",
      "Recruitment for mechanical engineers, robotics specialists, and operations managers.",
      "AI/ML-driven demand forecasting and logistics optimization."
    ],
    impact: "We help manufacturers reduce downtime, optimize resources, and enhance production efficiency."
  },
  {
    title: "Energy & Utilities",
challenge: "Energy and utility companies must adopt renewable sources, modernize infrastructure, ensure regulatory compliance, and balance sustainability with affordability."
,
    solution: [
      "Smart grid and renewable energy management systems.",
      "AI-powered energy demand forecasting and consumption analytics.",
      "Recruitment for renewable energy engineers, environmental specialists, and compliance officers.",
      "IoT-enabled monitoring systems for water, power, and natural resources."
    ],
    impact: "We drive sustainability, efficiency, and compliance for energy and utility providers worldwide."
  },
  {
    title: "Travel & Hospitality",
    challenge: "The travel industry requires seamless digital booking experiences, customer personalization, and efficient workforce management.",
    solution: [
      "AI-driven booking engines with personalized travel suggestions.",
      "Mobile apps for hotel/resort management and customer engagement.",
      "On-demand staffing platforms for hospitality professionals.",
      "Chatbots and virtual assistants for customer support."
    ],
    impact: "We enhance guest experiences, optimize operations, and enable businesses to scale globally in the travel sector."
  }
];


export const expertiseList = [
  "Deep understanding of domain-specific challenges.",
  "Expertise across multiple business models (startup, SME, enterprise).",
  "Dual expertise in talent + technology for holistic solutions.",
  "Track record of delivering measurable value across industries."
];
